var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuReferralsCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "User-Add-Plus--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Add Plus Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-add-plus--actions-add-close-geometric-human-person-plus-single-up-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M8 3c0 1.65685 -1.34315 3 -3 3S2 4.65685 2 3s1.34315 -3 3 -3 3 1.34315 3 3Zm2.75 4.5c0.4142 0 0.75 0.33579 0.75 0.75V10h1.75c0.4142 0 0.75 0.3358 0.75 0.75s-0.3358 0.75 -0.75 0.75H11.5v1.75c0 0.4142 -0.3358 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75V11.5H8.25c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75H10V8.25c0 -0.41421 0.3358 -0.75 0.75 -0.75ZM5 6.99997c1.49337 0 2.83382 0.65469 3.75 1.69272v0.0573h-0.5c-1.10457 0 -2 0.89543 -2 2.00001 0 0.753 0.41612 1.4088 1.03095 1.75H0.5c-0.276142 0 -0.5 -0.2239 -0.5 -0.5 0 -2.76145 2.23858 -5.00003 5 -5.00003Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReferralsCurrent);
export default __webpack_public_path__ + "static/media/menu-referrals-current.ce9ffa7ad9582b8ec07ab960e79366e5.svg";
export { ForwardRef as ReactComponent };